<div class="playbooks">
  <div class="playbooks-tabs">
    <div class="playbooks-tabs-content">
      @if (tabs.length > 0) {
        <app-sidepanel-tabs [tabs]="tabs" [currentTabIndex]="currentTabIndex" (tabOnSelection)="onTabSelection($event)">
        </app-sidepanel-tabs>
      }
    </div>
    <div class="divider"></div>
  </div>
  <div class="playbooks-options">
    @if (currentTabIndex === 0) {
      <app-playbooks-list></app-playbooks-list>
    } @else if (currentTabIndex === 1) {
      <app-playbooks-marketplace></app-playbooks-marketplace>
    } @else if (currentTabIndex === 2) {
      <app-executions-list></app-executions-list>
    }
  </div>
</div>
